import { PostAPI } from 'Components/Helper/Helpers';

export const Select = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/Select');
};
export const Delete = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/Delete');
};
export const Insert = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/Insert');
};
export const Update = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/Update');
};
export const SelectByID = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/SelectByID');
};

export const SelectReport = async (request) => {
    return PostAPI(request, 'DematGrowthLossMaster/SelectReport');
};
